export default __webpack_public_path__ + "static/flow-illustration-84cb99a1541a1663640944b048adcce8.png";